import React from "react";
import { Spin } from "antd";
import { ITextInputErrorWarning } from "../../../store/@types/misc";
import { twMerge } from "tailwind-merge";

export type ITextInput = {
  label?: string;
  label_icon?: React.ReactNode;
  name: string;
  value: string;
  type: "email" | "text" | "number" | "date" | "password" | "phone";
  placeholder: string;
  required: boolean;
  status?: ITextInputErrorWarning;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  icon?: React.ReactNode;
  labelClassName?: string;
  right_icon?: React.ReactNode;
  onRightIconClick?: () => void;
  loading?: boolean;
  onBlur?: () => void;
  customBgColor?: string;
};

const TextInput: React.FC<ITextInput> = ({
  label,
  label_icon,
  name,
  value,
  type,
  placeholder,
  required,
  status,
  onChange,
  icon,
  labelClassName,
  right_icon,
  onRightIconClick,
  loading,
  onBlur,
  customBgColor,
}) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const borderColor = status ? "border-[red]" : "border-[#e5e7eb]";
  const iconColor = status ? "text-[red]" : "text-black";
  return (
    <div className="w-full ">
      <label
        className={twMerge(
          "flex gap-3 items-center text-md font-medium",
          labelClassName,
        )}
      >
        {label_icon} {label}
      </label>
      <div
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={`flex w-full h-11 border items-center rounded-lg mt-1 text-gray-900 px-3 py-2 ${customBgColor} ${
          isFocused ? "border-primary-500" : borderColor
        } focus-within:ring focus-within:ring-primary-100/30`}
      >
        {icon && (
          <div
            className={`mr-2 border-r border-r-gray-50/20 pr-2 ${iconColor}`}
          >
            {icon}
          </div>
        )}
        <input
          type={type}
          value={value}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className="w-full !outline-none px-0 py-0 text-sm border-none focus:border-transparent focus:ring-0"
          onBlur={onBlur}
          style={{
            background: "transparent",
            transition: "background-color 9999s ease-in-out 0s",
          }}
        />
        {loading && <Spin size="small" className="ml-2" />}
        {right_icon && (
          <div
            onClick={onRightIconClick}
            className="flex items-center justify-center ml-2 px-3 py-2 bg-primary-500 rounded-md text-white hover:bg-primary-900 transition-all duration-200 cursor-pointer"
          >
            {right_icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default TextInput;
